/**
 * Decoupled re-used function to check either the website field (input) is required for the registration.
 *
 * @param {number} productId
 * @return {boolean}
 */
export default (productId) => {
    // Blacklist DB, Uptime monitoring, doBoard do not require website (optional parameter).
    return ![2, 6, 7].includes(productId);
}
